import script from "./Tabs.vue?vue&type=script&lang=ts&setup=true"
export * from "./Tabs.vue?vue&type=script&lang=ts&setup=true"

import "./Tabs.vue?vue&type=style&index=0&id=75bb3f46&scoped=true&lang=scss"

import exportComponent from "/var/icar/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-75bb3f46"]])

export default __exports__